import { render, staticRenderFns } from "./DocumentTemplateEdit.vue?vue&type=template&id=518c0e99&scoped=true"
import script from "./DocumentTemplateEdit.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplateEdit.vue?vue&type=style&index=0&id=518c0e99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518c0e99",
  null
  
)

export default component.exports